
import * as type from './types';

export function deleteMyWorksAlbum(data) {
    return {
        type: type.DELETE_MY_WORKS_ALBUM_REQUESTED,
        data: data,
    }
};